import * as vp from 'vopay';
import { useEffect, FunctionComponent, useState } from 'react';
import useFetchEFTFundTransaction from '@/hooks/useApi/useFetchEFTFundTransaction';
import EftFundingTransactionInfo from './EftFundingTransactionInfo';
import LinkedTransactionInfo from './LinkedTransactionInfo';
import { useUserSettingsProvider } from '@/providers/UserSettings.provider';

type EftFundingTransactionProps = {
  TransactionID: string;
  Notes: string;
};

type FC = FunctionComponent<EftFundingTransactionProps>;

const EftFundingTransactionContainer: FC = (props: EftFundingTransactionProps) => {
  const { TransactionID, Notes } = props;
  const [currentTransactionId, setCurrentTransactionId] = useState<string>();
  const [transaction, setTransaction] = useState<vp.EftFundingTransactionResponse>();
  const [eftFundTransaction, getEftFundTransaction, resetTransactionsId] = useFetchEFTFundTransaction({ bearer: '' });
  const [isDataFeched, setIsDataFeched] = useState(false);
  const [parentTransactions, setParentTransactions] = useState<vp.LinkedTransactionsMap>();
  const { userSettings } = useUserSettingsProvider();

  useEffect(() => {
    getEftFundTransaction({ TransactionID, Timezone: userSettings.timezone });
    setIsDataFeched(true);
  }, [currentTransactionId, TransactionID]);

  useEffect(() => {
    if (eftFundTransaction) {
      setTransaction(eftFundTransaction);
    }
  }, [eftFundTransaction]);

  if (currentTransactionId !== TransactionID) {
    setCurrentTransactionId(TransactionID);
    resetTransactionsId();
  }
  useEffect(() => {
    if (isDataFeched && Object.values(eftFundTransaction).length > 0 && eftFundTransaction.SubTransactions) {
      const subTransactionsList: vp.LinkedTransactionsMap = Object.values(eftFundTransaction.SubTransactions);

      setParentTransactions(subTransactionsList);
    }
  }, [eftFundTransaction]);

  return (
    <div>
      {transaction && <EftFundingTransactionInfo transaction={transaction} Notes={Notes} />}
      {parentTransactions && (
        <LinkedTransactionInfo LinkedTransactions={parentTransactions} Currency={transaction?.Currency || 'CAD'} />
      )}
    </div>
  );
};

export default EftFundingTransactionContainer;
